module.exports = __webpack_public_path__ + "img/cov-alumni.51558643.jpg";